/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getDocument = /* GraphQL */ `
  query GetDocument($unique_id: ID!) {
    getDocument(unique_id: $unique_id) {
      unique_id
      title
      s3Uri
      type
      content
      uploadedBy
      source
      uploadedAt
      insights
      __typename
    }
  }
`;
export const listDocuments = /* GraphQL */ `
  query ListDocuments(
    $filter: TableDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        unique_id
        title
        s3Uri
        type
        content
        uploadedBy
        source
        uploadedAt
        insights
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!, $timestamp: AWSDateTime) {
    getMessage(id: $id, timestamp: $timestamp) {
      id
      conversationId
      userId
      isBot
      content
      supportingContent
      citations
      explanation
      timestamp
      __typename
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $filter: TableMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conversationId
        userId
        isBot
        content
        supportingContent
        citations
        explanation
        timestamp
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) {
      id
      userId
      title
      summary
      createdAt
      __typename
    }
  }
`;
export const listFeedback = /* GraphQL */ `
  query ListFeedback(
    $filter: TableFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedback(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        feedbackId
        userId
        content
        createdAt
        messageId
        conversationId
        modelId
        type
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listConversations = /* GraphQL */ `
  query ListConversations(
    $filter: TableConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConversations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        title
        summary
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
